<template>
	<div class="container-loading">
		<div class="loading"></div>
	</div>
</template>
<script>
export default {
	name: 'LoadContent'
}
</script>
<style lang="scss" scoped>
.container-loading {
	position: relative;
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	padding: 200px 0px;

	.loading {
		width: 60px;
		height: 60px;
		margin: 0 auto;
		border-radius: 30px;
		box-sizing: border-box;
		border: solid 10px rgba($main-color, 1);
		border-top-color: #fff;
		animation: spin 1s infinite linear;
	}
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
